<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { computed, reactive, ref, toRaw } from 'vue';

import DetailedJobAttachmentsDropZoneField from '@/components/fields/DetailedJobAttachmentsDropZoneField.vue';
import KTextField from '@/components/fields/KTextField.vue';
import KTextareaField from '@/components/fields/KTextareaField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  subject?: string | null;
  message?: string | null;
  attachments?: File[];
}

export interface ValidData {
  subject: string;
  message: string;
  attachments?: File[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});

const attachmentsLimit = 5;

const isAttachmentsLimit = computed(() => {
  return (
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    attachmentsLimit && (formData.attachments?.length || 0) > attachmentsLimit
  );
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.newRFCDialogForm"
    data-testid="newRFCDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.subject"
      label="Subject"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextareaField
      v-model="formData.message"
      label="Message"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :rows="4"
      :class="$style.field"
      placeholder="Message"
    />
    <DetailedJobAttachmentsDropZoneField
      v-model="formData.attachments"
      :limit="attachmentsLimit"
      :disabled="props.loading"
      :class="$style.field"
    />
    <input
      type="submit"
      class="hidden"
      :disabled="props.loading || isAttachmentsLimit"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newRFCDialogForm {
}
  .field {
    margin-bottom: 0.5rem;
  }
</style>
